import { isNil } from "./is-nil";
import { Nullable } from "./nullable.types";

export function isDefined<T>(value: Nullable<T>): value is NonNullable<T> {
  return !isNil(value);
}
